<span mat-dialog-title>


    <input required placeholder="{{ 'PROJECTS.NAME' | translate }}" [(ngModel)]="currentProject.name" name="name">


</span>
<div  mat-dialog-content class="project-container">
   <div class="row">

        <div class="col-sm-6 pt-2 pb-2">
          <!--<app-dialog></app-dialog>-->
           <!--<mat-card  class="full-width full-height">
                <mat-card-header>
                    <div mat-card-avatar><mat-icon><fa-icon [icon]="['fal', 'object-group']"></fa-icon></mat-icon></div>
                    <mat-card-title translate>GENERIC.PLOTTABLE</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                     <mat-accordion>
                       <proj-item *ngFor="let cur of [
                        ['photo-dzi','image'],
                        ['three-d-tiles','cube'],
                        ['terrain',['fal','globe']],
                        ['image/tiff',['far','globe-asia']],
                        ['laslaz','cloud']
                       ]"  [metaType]="cur[0]" [project]="currentProject" [metaIcon]="cur[1]" (onDel)="removeAll($event)" (onAdd)="browseTT($event)" (onAddFolder)="browseTransformForFolder($event)"></proj-item>


                    </mat-accordion>
                </mat-card-content>

            </mat-card>-->
        </div>
        <div class="col-sm-6 pt-2 pb-2">
            <!--<mat-card class="full-width">
                <mat-card-header>
                    <div mat-card-avatar><mat-icon><fa-icon icon="folder"></fa-icon></mat-icon></div>
                    <mat-card-title translate>TYPES.folder</mat-card-title>
                </mat-card-header>
                <mat-card-content [vlist]="currentProject.folders">

                </mat-card-content>
                <mat-card-actions class="text-right"><button (click)="browseFiles()" mat-button><fa-icon icon="plus"></fa-icon> {{ 'GENERIC.ADD' | translate }}</button></mat-card-actions>
            </mat-card>
             <mat-card  class="full-width">
                <mat-card-header>
                    <div mat-card-avatar><mat-icon><fa-icon icon="tasks"></fa-icon></mat-icon></div>
                    <mat-card-title translate>TYPES.workflow</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ng-template let-query="query">

                    </ng-template>
                </mat-card-content>
                <mat-card-actions class="text-right"><button (click)="browseFiles()" mat-button><fa-icon icon="plus"></fa-icon> {{ 'GENERIC.ADD' | translate }}</button></mat-card-actions>
            </mat-card>-->
            </div>

            <!--
            <mat-card class="col-sm-6">
                <mat-card-header>
                    <div mat-card-avatar><mat-icon><i class="fa fa-tasks"></i></mat-icon></div>
                    <mat-card-title>Workflows</mat-card-title>
                </mat-card-header>
                <mat-card-content></mat-card-content>
                <mat-card-actions></mat-card-actions>
            </mat-card>
            -->


    </div>

</div>
<div mat-dialog-actions class="text-right">
    <button mat-raised-button color="warn" (click)="deleteCurrent()"><fa-icon icon="trash"></fa-icon> {{ 'GENERIC.DELETE' | translate }}</button>
    <button [disabled]="currentProject.name.length < 2" mat-raised-button color="primary" (click)="saveCurrent()"><fa-icon icon="save"></fa-icon> {{ 'GENERIC.SAVE' | translate }}</button>
    <button mat-button (click)="dialogRef.close(false)"> {{ 'GENERIC.CANCEL' | translate }}</button>
</div>
